<template>
  <div>
    <!-- 기본으로 쓰는 백오피스 상품 등록페이지 -->
    <basic-product-option v-if="!isLaunchpack"></basic-product-option>
    <!-- 마스터 백오피스 상품 등록페이지 -->
    <lp-product-option v-if="isLaunchpack"></lp-product-option>
  </div>
</template>

<script>
  import BasicProductOption from "./BasicProductOption";
  import LpProductOption from "./LpProductOption";

  export default {
    layout: 'Main',
    components: {
      LpProductOption,
      BasicProductOption
    },
    watch:{

    },
    created() {
      this.getPackages();
    },
    data() {
      return {
        packages: []
      }
    },
    methods: {
      getPackages(){
        this.packages = this.$store.getters.getPackages;
      },
    }
  }
</script>
